import React from "react";

const Ourfacilities = () => {
    return(
        <div>
           <header className>
        <nav className="navbar navbar-expand-lg">
          <div className="container">
          <img src="assets/images/la-logo-240px.png" className="la-logo" alt=""></img>
            <a className="navbar-brand" href="index.html"><h2>Lakshan Associates</h2></a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarResponsive">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <a className="nav-link" href="/home">Home
                    <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/about">About Us</a>
                </li>
                <li className="nav-item ">
                  <a className="nav-link" href="/ourservices">Our Services</a>
                </li>
                <li className="nav-item active">
                  <a className="nav-link" href="/ourfacilities">Our Facilities</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/contactus">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
        {/* Page Content */}
             <div className="page-heading header-text">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>Our Facilities</h1>
                <span>We have plastic, aluminium, Ldpe, thermocoal, rubbish recycling units.</span>
              </div>
            </div>
          </div>
    </div> 

    {/* Gallery */}

    <div className="section-heading facility-header">
                  <h2>Our <em>Facilities</em></h2>
                  <span>What we have in our industry</span>
                </div>

    <div className="gallery">
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/facility-1.jpg"/>
            <h4>Special Attachment Tractor</h4>
            <h5>1 No</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/forklifts.png" />
            <h4>Forklifts</h4>
            <h5>3T-3 Nos & 5T-2 Nos</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/vehicles.png" />
            <h4>Total Vehicle Strength</h4>
            <h5>25 Nos</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/cranes_earthmoving.png" />
            <h4>Cranes</h4>
            <h5>12T,12T,14T,16T,20T</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/jcb.png" />
            <h4>JCB Earth Moving Vehicles</h4>
            <h5>4 Nos</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/Wooden recycling Unit-1.jpg" />
            <h4>Making Doors</h4>
            <h5>Wooden Recycling Unit</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/Wooden recycling Unit-2.jpg" />
            <h4>Making Furnitures</h4>
            <h5>Wooden Recycling Unit</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/Wooden recycling Unit-3.jpg" />
            <h4>Making Wood Reaper</h4>
            <h5>Wooden Recycling Unit</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/Plastic Recycling Unit-1.jpg" />
            <h4>Processing Machine</h4>
            <h5>Plastic Recycling Unit</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/Plastic Recycling Unit-2.jpg" />
            <h4>LDPE Granules</h4>
            <h5>Plastic Recycling Unit</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/Plastic Recycling Unit-3.jpg" />
            <h4>Nylon Granules</h4>
            <h5>Plastic Recycling Unit</h5>
          </div>
        </a>
        <a href="#" className="card">
          <div className="card-wrapper">
            <div className="hidden-cover" />
            <img src="assets/images/Carton Box-1.jpg" />
            <h4>Paper Rolls</h4>
            <h5>Carton Box</h5>
          </div>
        </a>
      </div>
        </div>
    )
}

export default Ourfacilities;